/**
 * Created by murat on 9/25/2016.
 */
import * as _ from 'lodash';
import {Router, ActivatedRoute, NavigationStart} from '@angular/router';
import {Injectable} from '@angular/core';
import {HelperService} from './helper.service';

@Injectable()
export class RouterService {
  get registeredRoutes(): string[] {
    return this._registeredRoutes;
  }

  set registeredRoutes(value) {
    this._registeredRoutes = value;
  }

  private _registeredRoutes: string[];

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private helperService: HelperService) {
    this._registeredRoutes = [];
  }

  public referrer() {
    const countOfRegisteredRoutes = this.registeredRoutes.length;
    const hasRoutes = !_.isUndefined(this.registeredRoutes[countOfRegisteredRoutes - 2]);
    return hasRoutes ? this.registeredRoutes[countOfRegisteredRoutes - 2] : 'https://ustala.com';
  }

  public listenChanges() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.helperService.scrollToTop();
        const routesCount = this.registeredRoutes.length;
        const alteredURL = this.removeParam('token', event.url);
        if (this.registeredRoutes[routesCount - 1] !== alteredURL) {
          this.registeredRoutes.push(alteredURL);
        }
      }
    });
  }

  private removeParam(key, sourceURL) {
    let rtn = sourceURL.split('?')[0],
      param,
      params_arr = [];
      const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
      params_arr = queryString.split('&');
      for (let i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split('=')[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      rtn = rtn + '?' + params_arr.join('&');
    }
    return rtn;
  }
}
